// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  // console.log('DOM loaded, initializing mega menu hover...');
  
  const headerMenus = document.querySelectorAll('header-menu');
  // console.log('Found header-menu elements:', headerMenus.length);
  
  headerMenus.forEach((menu, index) => {
    // console.log(`Initializing menu ${index + 1}`);
    
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');
    const megaMenuContent = menu.querySelector('.mega-menu__content');
    
    let hoverTimeout = null;
    const openDelay = 100;
    const closeDelay = 200;
    
    // Open on hover
    menu.addEventListener('mouseenter', function() {
      // console.log('Mouse entered menu', index + 1);
      clearTimeout(hoverTimeout);
      
      hoverTimeout = setTimeout(() => {
        // console.log('Opening menu', index + 1);
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded', 'true');
      }, openDelay);
    });
    
    // Close on mouse leave
    menu.addEventListener('mouseleave', function() {
      // console.log('Mouse left menu', index + 1);
      clearTimeout(hoverTimeout);
      
      hoverTimeout = setTimeout(() => {
        // console.log('Closing menu', index + 1);
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
      }, closeDelay);
    });
    
    // Prevent click toggle
    summary.addEventListener('click', function(event) {
      // console.log('Summary clicked, preventing default');
      event.preventDefault();
      event.stopPropagation();
    });
    
    // Keep menu open when hovering over content
    if (megaMenuContent) {
      megaMenuContent.addEventListener('mouseenter', function() {
        // console.log('Mouse entered mega menu content');
        clearTimeout(hoverTimeout);
      });
    }
  });
  
  // Close on click outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('header-menu')) {
      // console.log('Clicked outside, closing all menus');
      document.querySelectorAll('header-menu details[open]').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
    }
  });
  
  // Close on ESC key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      // console.log('ESC pressed, closing all menus');
      document.querySelectorAll('header-menu details[open]').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
    }
  });
});